import React, { useEffect } from 'react'
import SupportInformation from './Information'
import Create from './Create'
import Messages from './Messages'
import View from './View'
import styles from './styles.css'
import Loading from 'App/components/Loading'
import Button from 'orionsoft-parts/lib/components/Button'
import { useAssignConversation, useConversation, useGetMessages } from './hooks'
import { useCreateConversation } from 'src/App/Pages/Inbox/Vehicle/hooks'
import { getMessengerVehicleURL } from 'App/Root/url'

import ConversationHeader from './ConversationHeader'

export function Fallback() {
  return (
    <>
      <div className={styles.loading}>
        <Loading />
      </div>
      <div className={styles.information}></div>
    </>
  )
}

export function ConversationId({ conversationId }) {
  return (
    <div className={styles.categoryId}>
      <h4>ID Conversación</h4>
      <div>{conversationId}</div>
    </div>
  )
}

export default function Conversation({ match, history }) {
  const { conversationId } = match.params

  const { vehicle, assignedAgent, ...conversation } = useConversation(conversationId)
  const { assignConversation } = useAssignConversation(conversationId)

  const { createConversation } = useCreateConversation({ vehicleId: vehicle._id, history })

  const { messages, refetch } = useGetMessages({ conversationId })

  useEffect(() => {
    refetch()
  }, [conversation && conversation.lastActivityAt])

  const buttonLabel = vehicle.activeConversation ? 'Ir a la última' : 'Iniciar una'

  const handleMessengerClick = () => {
    const messengerURL = getMessengerVehicleURL(vehicle._id)
    window.open(messengerURL, '_blank')
  }

  return (
    <>
      <div className={styles.conversation}>
        <ConversationHeader
          vehicle={vehicle}
          assignedAgent={assignedAgent}
          assignConversation={assignConversation}
        />
        <Messages
          conversation={conversation}
          messages={messages}
          lastEndedConversations={
            conversation.isActiveConversation ? vehicle.lastEndedConversations : []
          }
        />
        <div className={styles.messengerButton}>
          <Button
            primary
            onClick={handleMessengerClick}
            style={{ width: '100%' }}
          >
            Abrir En Messenger
          </Button>
        </div>
        {conversationId && conversation.isActiveConversation ? (
          <>
            <Create conversationId={conversationId} refetchMessages={refetch} />
            <View conversationId={conversationId} />
          </>
        ) : (
          <div className={styles.chatButton}>
            <p>Esta conversación ya no está activa</p>
            <Button primary onClick={createConversation}>
              {buttonLabel} conversación
            </Button>
          </div>
        )}
      </div>
      <div className={styles.information}>
        {conversationId ? (
          <>
            <ConversationId conversationId={conversationId} />
            <SupportInformation inboxView conversationId={conversationId} />
          </>
        ) : null}
      </div>
    </>
  )
}
